import * as React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { ClientSelect } from '@components/client-select'
import { ClientUser } from '@models/clients'
import { useModal } from '@components/modals/use-modal'
import { EndlessHolidayCreateFormInputs } from '@modules/product-package/transactions/create/modal'
import { InvoiceForm } from '@components/invoice-form'
import { ProductPackageCreateFormBaseFields } from '@modules/product-package/common/create-modal-base-fields'
import { ProductPackageKind } from '@modules/product-package/models'
import { useProductsAppData } from '@modules/products/hooks/use-products-app-data'
import { useGetProductPackageSetDetailsQuery } from '@api/endless-holiday'
import { getById } from '@helpers/utils'
import { SubscriptionCreateFormAdditionalClient } from '@modules/subscription/create/steps/additional-client'

interface Props {
  initialClient: ClientUser | undefined
  productPackageKind: ProductPackageKind
}

export const ProductPackageFormClientData = ({ initialClient, productPackageKind }: Props) => {
  const [client, setClient] = React.useState<ClientUser | undefined>(initialClient)
  const [handleToggleClientDialog] = useModal('ClientDialog', { setClient })

  const { formState, setValue, getValues, control } = useFormContext<EndlessHolidayCreateFormInputs>()
  const selectedSet = useWatch({ control, name: 'product_package_set' })
  const { product_package_sets } = useProductsAppData()
  const packageSet = getById(product_package_sets, selectedSet?.value)
  const { currentData: packageSetDetails } = useGetProductPackageSetDetailsQuery(packageSet?.urls.details, {
    skip: !packageSet,
  })
  const allowAdditionalClient =
    productPackageKind === 'voucher' &&
    packageSetDetails?.products.some(product => product.codes_per_package && Object.keys(product.season ?? {}).length)

  React.useEffect(() => {
    if (!allowAdditionalClient) setValue('clients', [])
  }, [allowAdditionalClient])

  React.useEffect(() => {
    setValue('client', client)
  }, [client])

  return (
    <div className="">
      <ClientSelect
        label={<span className="text-secondary mt-0 fw-semi-bold">Wyszukaj klienta</span>}
        setClient={setClient}
        client={client}
        handleToggleClientDialog={handleToggleClientDialog}
        error={formState.errors.client}
        colSize={8}
        formGroupClassName="px-2"
      />

      {allowAdditionalClient && <SubscriptionCreateFormAdditionalClient initialClients={getValues('clients')} />}

      <div className="mx-1">
        <ProductPackageCreateFormBaseFields productPackageKind={productPackageKind} />
      </div>
      <InvoiceForm wrapperClassName="mx-0 px-2" />
    </div>
  )
}
